/**
 * 水印设置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WidgetManageService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 工作台组件接口
  /**
   * 分页查询
   * @param param
   * @returns {Observable<any>}
   */
  queryPageList(param) {
    const url = this.prefix + 'widget/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 根据ID查询
   * @param param
   * @returns {Observable<any>}
   */
  queryById(param) {
    const url = this.prefix + 'widget/queryById';
    return this.http.Post(url, param);
  }

    /**
   * 根据ID批量删除
   * @param param
   * @returns {Observable<any>}
   */
  deleteBatch(param) {
    const url = this.prefix + 'widget/deleteBatch';
    return this.http.Post(url, param);
  }

     /**
   * 新增
   * @param param
   * @returns {Observable<any>}
   */
  save(param) {
    const url = this.prefix + 'widget/save';
    return this.http.Post(url, param);
  }

  /**
   * 更新
   * @param param
   * @returns {Observable<any>}
   */
  updateById(param) {
    const url = this.prefix + 'widget/updateById';
    return this.http.Post(url, param);
  }
}
